// extracted by mini-css-extract-plugin
export default {"container":"popup_container__Acl1h","fadein":"popup_fadein__SnxxY","fadeout":"popup_fadeout__zb4nx"};